/**
 * Build a navigation URL that the Google Maps app (or website) can open
 * directly. The `dir` endpoint with `api=1` is the universal format —
 * Google deep-links to the native app on mobile and shows the directions
 * preview on desktop.
 */
export const getGoogleMapsNavUrl = (
  lat: number,
  lng: number,
): string =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${lat},${lng}`,
  )}`;

/**
 * Compute the centroid (mean of vertices) of a polygon. Cheap approximation
 * — for arbitrary non-convex polygons it can fall outside the shape, but
 * for the typical project/warehouse boundaries we draw it lands inside and
 * is good enough for "navigate me roughly to this area".
 */
export const polygonCentroid = (
  coords: { lat: number; lng: number }[],
): { lat: number; lng: number } | null => {
  if (!coords || coords.length === 0) return null;
  const sum = coords.reduce(
    (acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }),
    { lat: 0, lng: 0 },
  );
  return { lat: sum.lat / coords.length, lng: sum.lng / coords.length };
};
